import React, {useEffect, useState} from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {URLS} from "@/lib/urls";
import {useApiReadStudentPaymentBalance} from "@/api/payment";
import RenderIf from "@/components/render-if";
import {Alert, Button, Card, Checkbox, Divider, Form, Input, Popconfirm, Typography} from "antd";
import {useApiReadStudentConfigs} from "@/api/config";
import nl2br from "react-nl2br";
import TableSearch from "@/components/table/tableSearch";
import {useApiCreateStudentRefund, useApiDeleteStudentRefund, useApiSearchStudentRefunds} from "@/api/refund";
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import {formatDateFull} from "@/lib/utils/date";
import {SafetyCertificateOutlined, WalletOutlined} from "@ant-design/icons";
import {useApiReadStudentProfile} from "@/api/userAcademy";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import RefundStatusEnumComponent from "@/components/EnumComponents/RefundStatusEnumComponent";

const {Text, Title} = Typography;

function StudentRefundPage(props) {
    const [agree, setAgree] = useState(false)
    const {data: configData, isLoading: isLoadingConfigs} = useApiReadStudentConfigs('refund_terms');
    const {data: balance, isPending: isPendingBalance, refetch: refetchBalance} = useApiReadStudentPaymentBalance()
    const {data: user, isPending: isPending, isSuccess, refetch, isRefetching} = useApiReadStudentProfile()
    const {mutate: refundRequest, isPending: isPendingRefundRequest} = useApiCreateStudentRefund()
    const {mutate: rejectRequest, isPending: isPendingRejectRequest} = useApiDeleteStudentRefund()
    const [form] = Form.useForm();
    const [needRefetch, setNeedRefetch] = useState(false)


    useEffect(() => {

        form.setFieldsValue({
            shaba: user?.data?.data?.payment?.shaba ?? '',
            cardnumber: user?.data?.data?.payment?.cardnumber ?? '',
            owner: user?.data?.data?.payment?.owner ?? '',
            bank: user?.data?.data?.payment?.bank ?? '',
        });

    })


    function handleRejectRequest(id) {
        rejectRequest({id: id}, {
            onSuccess: data => {
                ApiHandleSuccessMessage(data)
                setNeedRefetch(true)
                setAgree(false)
                refetch().then(r => {
                })
                refetchBalance().then(balance => {
                })
            },
            onError: error => {
                ApiHandleErrorMessage(error)
            }
        })
    }

    function handleFinishForm(values) {
        refundRequest(values, {
            onSuccess: data => {
                ApiHandleSuccessMessage(data)
                setNeedRefetch(true)
                setAgree(false)
                refetch().then(r => {
                })
                refetchBalance().then(balance => {
                })
            },
            onError: error => {
                ApiHandleErrorMessage(error)
            }
        })

    }

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },
        {
            title: 'مبلغ',
            dataIndex: 'amount',
            key: 'amount',
            render: function (text, record) {
                return (<>
                    <div className="flex gap-1">
                        {toFaNumberFormat(text)}
                        <span className={'text-gray-400'}>  تومان</span>
                    </div>

                </>)

            }
        }, {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: function (text, record) {
                return (
                    <>
                        <div className="flex flex-wrap gap-1">
                            <div>
                                <RefundStatusEnumComponent text={text}/>
                            </div>
                            <div>
                                <RenderIf condition={record?.message}>
                                    <p className={'border border-2 p-1 rounded-lg'}>{record.message}</p>
                                </RenderIf>

                            </div>
                            <RenderIf condition={text === 'pending'}>
                                <div className="flex flex-wrap gap-1">
                                    <div className={'max-w-md'}>
                                        درخواست شما در انتظار تایید است. این فرایند ممکن است زمان بر باشد لطفا طی
                                        روز‌های آینده به همین صفحه مراجعه کرده و از آخرین وضعیت درخواست خود مطلع شوید

                                    </div>
                                    <Popconfirm title={'آیا از لغو درخواست اطمینان دارید؟'}

                                                onConfirm={() => handleRejectRequest(record.id)}
                                    >

                                        <Button loading={isPendingRejectRequest} variant={'solid'} size={'small'}
                                                color={'danger'}>
                                            لغو درخواست
                                        </Button>
                                    </Popconfirm>
                                </div>


                            </RenderIf>
                        </div>

                    </>

                )
            }
        }, {
            title: 'تاریخ درخواست',
            dataIndex: 'created_at',
            key: 'created_at',
            render: function (text, record) {
                return formatDateFull(text)
            }
        },
    ]


    return (
        <StudentLayout pageTitle={'درخواست بازگشت وجه'} backTo={URLS.student.billing.dashboard}>
            <div>
                <RenderIf
                    condition={
                        configData?.data?.data?.value &&
                        balance?.data?.data?.budget > 300000
                    }
                >
                    <Card
                        bordered={false}
                        className="rounded-2xl shadow-sm"
                        bodyStyle={{padding: 24}}
                    >
                        <div className="flex items-center gap-3 mb-5">
                            <SafetyCertificateOutlined
                                style={{
                                    fontSize: 30,
                                    color: "#faad14",
                                }}
                            />

                            <div>
                                <Title level={5} className="!mb-0">
                                    قوانین بازگشت وجه
                                </Title>

                                <Text type="secondary">
                                    لطفاً قبل از ثبت درخواست قوانین را مطالعه نمایید.
                                </Text>
                            </div>
                        </div>

                        <Alert

                            type="warning"
                            className="rounded-xl"
                            description={
                                <div className="leading-8">
                                    {nl2br(configData?.data?.data?.value)}
                                </div>
                            }
                        />

                        <Divider/>

                        <Checkbox
                            checked={agree}
                            onChange={(e) => setAgree(e.target.checked)}
                        >
                            <span className={'font-bold'}>
                            شرایط و قوانین را مطالعه کردم و می‌پذیرم.
                            </span>

                        </Checkbox>

                        <RenderIf condition={agree}>
                            <Form
                                form={form}
                                onFinish={handleFinishForm}>
                                <Card
                                    className="mt-5 rounded-2xl border-green-200 bg-green-50"
                                    bordered
                                >
                                    <div className="mb-5">
                                        <Title level={5} className="!mb-1">
                                            اطلاعات حساب بانکی
                                        </Title>

                                        <Text type="secondary">

                                            مبلغ بازگشت فقط به حسابی که اطلاعات آن را وارد می‌کنید واریز خواهد شد.
                                            <br/>
                                            لطفا اطلاعات درخواست شده را با دقت تکمیل کنید
                                        </Text>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                        <Form.Item
                                            label="نام بانک"
                                            name="bank"

                                            rules={[
                                                {
                                                    required: true,
                                                    message: "نام بانک را وارد کنید",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="medium"

                                                placeholder="مثال: بانک ملت"
                                            />
                                        </Form.Item>


                                        <Form.Item
                                            label="شماره کارت"
                                            name="cardnumber"

                                            rules={[
                                                {
                                                    required: true,
                                                    message: "شماره کارت را وارد کنید",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="medium"
                                                maxLength={16}
                                                style={{direction: "ltr"}}
                                                placeholder="6037-9912-3456-7890"
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label="شماره شبا"
                                            name="shaba"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "شماره شبا را وارد کنید",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="medium"
                                                style={{direction: "ltr", textAlign: "left"}}
                                                maxLength={24}
                                                minLength={24}
                                                placeholder="IR620170000000000000000000"
                                                addonAfter={'IR'}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label="نام صاحب حساب"
                                            name="owner"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "نام صاحب حساب را وارد کنید",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="medium"
                                                placeholder=""
                                            />
                                        </Form.Item>


                                    </div>

                                    <Divider/>

                                    <div className="flex flex-wrap items-center justify-between gap-4">

                                        <div>
                                            <Text type="secondary" className={'mb-2'}>
                                                مبلغ قابل بازگشت
                                            </Text>

                                            <div className="text-3xl font-bold text-green-600 mt-2">
                                                {balance?.data?.data?.budget?.toLocaleString()}
                                                <span className="text-base mr-2">
                        تومان
                    </span>
                                            </div>
                                        </div>

                                        <Button
                                            type="primary"
                                            size="large"
                                            htmlType="submit"
                                            loading={isPendingRefundRequest}
                                            icon={<WalletOutlined/>}
                                        >
                                            ثبت درخواست بازگشت وجه
                                        </Button>

                                    </div>
                                </Card>
                            </Form>
                        </RenderIf>
                    </Card>
                </RenderIf>
            </div>
            <div className={'p-1'}>
                <div>سوابق درخواست بازگشت وجه</div>
                <TableSearch
                    apiFn={useApiSearchStudentRefunds}
                    needRefetch={needRefetch}
                    setNeedRefetch={setNeedRefetch}
                    columns={columns}/>
            </div>

        </StudentLayout>
    );
}

export default StudentRefundPage;